import Image from 'next/image'
import { useRouter } from 'next/router'
import { useQuery } from 'urql'

import { ImgSVGUrl } from '@/components/img-svg-url'
import { graphql } from '@/gql'
import { formatNumberWithCommas } from '@/utils/number-helpers'

import IconLeft from '@/assets/icons/ic_logic-g-app_arrow-left.svg'

export const PointDetailTopBar = (): JSX.Element => {
  const router = useRouter()
  const playerId = router.query.playerId as string

  const [{ data }] = useQuery({
    query: PointDetailTopBarQuery,
    variables: {
      id: playerId,
    },
    pause: !playerId,
  })

  const player = data?.node?.__typename === 'Player' ? data.node : null

  return (
    <header className="grid h-[75px] grid-cols-[repeat(1,_60px_1fr_60px)] bg-white px-[7px] shadow-[0px_1px_1px_#00000026]">
      <button
        className="mt-[10px] flex flex-row items-center rounded-[4px] text-primary-100 active:bg-[#E2E4E8]"
        onClick={router.back}
      >
        <IconLeft width={30} />
        <span className="sr-only">戻る</span>
        {player ? (
          player.playerAvatar?.svg ? (
            <div className="mt-[3px] h-6 w-6 overflow-hidden rounded-full bg-basic-bg">
              <ImgSVGUrl
                svg={player.playerAvatar.svg}
                width={24}
                height={24}
                className="rounded-full"
              />
            </div>
          ) : (
            <Image
              src={
                player?.avatarId
                  ? `/images/img_avatar_${player?.avatarId}@2x.png`
                  : '/images/Blank-avatar@3x.png'
              }
              width={24}
              height={24}
              priority={true}
              className="mt-[3px] h-6 w-6 rounded-full"
              alt={player.name ?? 'avatar'}
            />
          )
        ) : null}
      </button>

      <div className="flex flex-col items-center justify-center gap-1">
        <div className="text-xs font-medium leading-[normal] text-secondary-text">
          ポイント
        </div>
        <h1 className="mt-[-8px] text-3xl font-medium leading-[normal] text-primary-100">
          {formatNumberWithCommas(
            player?.motivationPointVisualization.currentPoint
          )}
        </h1>
      </div>
    </header>
  )
}

const PointDetailTopBarQuery = graphql(`
  query PointDetailTopBarQuery($id: ID!) {
    node(id: $id) {
      ... on Player {
        __typename
        id
        name
        avatarId
        motivationPointVisualization {
          currentPoint
        }
        playerAvatar {
          svg
        }
      }
    }
  }
`)
